<template>
  <div
    v-if="!loading"
    class="top-product-list"
  >
    <div
      v-for="(item, i) in list.slice(0, 4)"
      class="top-product-list-item"
      @click="onItemClick(item, i === 3)"
    >
      <Image
        class="top-product-list-item__image"
        :src="item.imageUrl"
      />
      <div
        class="top-icon"
        v-if="item.salesRanking"
      >
        <Icon
          class="icon"
          name="hot"
        />
        <div class="text">
          TOP {{ item.salesRanking }}
        </div>
      </div>
      <div
        class="mask"
        v-if="i === 3"
      >
        More
      </div>
    </div>
  </div>
  <FactoryProductSkeleton v-else />
</template>

<script setup>
import { useQuery } from '@tanstack/vue-query'
import { Image } from '@/components/Image'
import { Icon } from '@/components/Icon'
import { buriedPointUtil, formatName, openURLWithChannelQuery } from '@/utils/utils'
import { retrieveFactoryTopProduct } from '@/api/factory'

import FactoryProductSkeleton from './FactoryProductSkeleton.vue'

const router = useRouter()

const props = defineProps({
  factoryId: {
    type: String,
    default: null
  }
})
const factoryId = computed(() => props.factoryId)

const { isPending, data: list, isError } = useQuery({
  queryKey: ['/appb/alibaba-common/supplier/product/top', factoryId],
  queryFn: () => retrieveFactoryTopProduct({
    sellerOpenId: factoryId.value,
    topN: 8
  }),
  enabled: computed(() => factoryId.value !== null),
  refetchOnWindowFocus: false
})
const loading = computed(() => isPending.value || isError.value)
const supplierName = computed(() => list.value[0]?.supplierName ?? '-')

const onItemClick = (item, isMore) => {
  if (isMore) {
    buriedPointUtil({ eventId: 'PPD212', others: { location: 'Top' } })
  } else {
    buriedPointUtil({ eventId: 'PPD204', others: { location: 'Top' } })
  }
  const { href } = isMore
    ? router.resolve({
      name: 'factory',
      params: {
        name: formatName(supplierName.value),
        id: factoryId.value
      }
    })
    : router.resolve({
      name: 'offer',
      params: {
        id: item.offerId
      },
      query: {
        key: btoa(item.monthSold)
      }
    })
  openURLWithChannelQuery(href)
}
</script>

<style lang="less" scoped>
.top-product-list {
  display: flex;
  gap: 8px;
  .top-product-list-item {
    position: relative;
    width: 64px;
    height: 64px;
    overflow: hidden;
    cursor: pointer;

    &:hover {
      .top-product-list-item__image {
        transform: scale(1.2);
      }
    }

    &__image {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      transition: all .2s ease-in-out;
    }

    .top-icon {
      position: absolute;
      top: 0;
      left: 0;
      height: 16px;
      border-radius: 4px 8px 8px 0;
      background-color: #FFFFFF88;
      padding: 1px 6px 1px 4px;
      display: flex;
      align-items: center;
      backdrop-filter: blur(20px);

      .icon {
        flex-shrink: 0;
        font-size: 12px;
        color: #F57231;
      }
      .text {
        color: #232323;
        font-size: 10px;
        font-family: mon-600;
        white-space: nowrap;
      }
    }
    .mask {
      position: absolute;
      inset: 0;
      background-color: #14141464;
      color: white;
      font-size: 11px;
      font-family: mon-600;
      text-decoration: underline;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
    }
  }
}
</style>
